<template>

  <HomepageWideLayout>

    <div class="vheight">
        <div class="vcenter">
          <div class="wrapper">
            <h2>Reset your password </h2>
            <h3>Then sign in again</h3>

            <div class="form-wrapper">
              <form @submit.prevent="submit" accept-charset="UTF-8" method="post">
                <b-form-group class="signup-form">
                    <div class="signup-fieldset">
                        <b-form-input v-model="password" placeholder="Password" required="required" type="password" class="signup-account-input" autofocus="autofocus" name="password"></b-form-input>
                        <b-form-input v-model="confirm_password" placeholder="Confirm Password" required="required" type="password" class="signup-account-input" autofocus="autofocus" name="confirm_password"></b-form-input>
                        <div class="error" v-if="loginError">{{loginError.toString()}}</div>

                        <b-button type="submit" name="commit" class="signup-account-submit" :disabled="loginBusy">
                            <span v-if="loginBusy">Changing Password...</span>
                            <span v-else>Change Password</span>
                        </b-button>
                    </div>
                </b-form-group>
              </form>
            </div>

        </div>
      </div>

      <div class="hero-bottom">
        <img src="/static/images/footer/product_footer.png">
      </div>

   </div>

  </HomepageWideLayout>


</template>


<style lang="scss" scoped>
@import '~scss/colors.scss';


.vheight {
  display: flex;
  flex-direction: column;
  height:calc(100vh - 200px);
  min-height:600px;
}
.vcenter {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 350px;
  margin: 0 auto;
}

.hero-bottom img{
  bottom: 0;
  width: 100%;
  height: auto;
  max-width: 974px;
  object-fit: cover;
  margin-top: 0
}

 .form-wrapper {
    display: block;
    margin: 0 auto;
  }


.signup-fieldset {
    display: block;
    min-width: 250px;
    max-width: 500px;
  }

  .signup-form {
    width: 100%;
    margin: 20px auto;
  }

  .signup-account-input,
  .signup-account-submit  {
    width: 100%;
    font-weight: 400;
    border-radius: 0;
    padding: 10px 20px;
    margin: 10px auto;
  }

  .signup-account-submit {
    background-color:$red;
    border: $red 1px solid;
    color: $white;
  }

</style>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["uid", "token"],
  data() {
    return { password: "", password2: "" };
  },
  computed: mapGetters(["loginBusy", "loginError"]),
  methods: {
    ...mapActions(["confirmReset"]),
    async submit() {
      await this.confirmReset({
        uid: this.uid,
        token: this.token,
        new_password1: this.password,
        new_password2: this.confirm_password
      });
      if (!this.loginError) this.$router.push("/signin");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/ResetPassword.vue